import {LiveForm, Nette} from 'live-form-validation';

Nette.validators = mergeDeep(Nette.validators, {
	min: function (elem, arg, val) {
		if (elem.type === 'number') {
			if (elem.validity.rangeUnderflow) {
				return false;
			} else if (elem.validity.badInput) {
				return null;
			}
		}

		if (elem.hasAttribute('data-provide') && (elem.getAttribute('data-provide') === 'datepicker' || elem.getAttribute('data-provide') === 'datetimepicker') && val) {
			if (val.indexOf('. ') >= 0) {
				val = val.split('. ');
				val = new Date(val[2] + "-" + val[1] + "-" + val[0]).toLocaleDateString('pt-br').split('/').reverse().join('-');
			}

			return arg === null || val >= arg;
		}

		return arg === null || parseFloat(val) >= arg;
	},

	max: function (elem, arg, val) {
		if (elem.type === 'number') {
			if (elem.validity.rangeOverflow) {
				return false;
			} else if (elem.validity.badInput) {
				return null;
			}
		}

		if (elem.hasAttribute('data-provide') && (elem.getAttribute('data-provide') === 'datepicker' || elem.getAttribute('data-provide') === 'datetimepicker') && val) {
			if (val.indexOf('. ') >= 0) {
				val = val.split('. ');
				val = new Date(val[2] + "-" + val[1] + "-" + val[0]).toLocaleDateString('pt-br').split('/').reverse().join('-');
			}

			return arg === null || val <= arg;
		}

		return arg === null || parseFloat(val) <= arg;
	},
});

LiveForm.getMessageElement = function (el) {
	// For multi elements (with same name) work only with first element attributes
	if (el.name && el.name.match(/\[\]$/)) {
		el = el.form.elements[el.name].tagName ? el : el.form.elements[el.name][0];
	}

	var id = el.getAttribute('data-lfv-message-id');
	if (!id) {
		// ID is not specified yet, let's create a new one
		id = this.getMessageId(el);

		// Remember this id for next use
		el.setAttribute('data-lfv-message-id', id);
	}

	if (el.nodeName === 'BUTTON') {
		return null;
	}

	var messageEl = document.getElementById(id);
	if (!messageEl) {
		// Message element doesn't exist, lets create a new one
		messageEl = document.createElement(this.options.messageTag);
		messageEl.id = id;
		if (el.style.display == 'none' && !this.hasClass(el, this.options.enableHiddenMessageClass)) {
			messageEl.style.display = 'none';
		}

		var parentEl = this.getMessageParent(el);
		if (parentEl && parentEl.classList.contains('input-group')) {
			parentEl.parentNode.append(messageEl);
		} else if (el.classList.contains('select2-hidden-accessible') && el.nextElementSibling.tagName === 'SPAN' && el.nextElementSibling.classList.contains('select2')) {
			parentEl.insertBefore(messageEl, el.nextElementSibling.nextSibling);
		} else if (parentEl === el.parentNode) {
			parentEl.insertBefore(messageEl, el.nextSibling);
		} else if (parentEl) {
			typeof parentEl.append === 'function' ? parentEl.append(messageEl) : parentEl.appendChild(messageEl);
		}
	}

	return messageEl;
};

LiveForm.options = {
	// CSS class of control's parent where error/valid class should be added; or "false" to use control directly
	showMessageClassOnParent: 'form-group',

	// CSS class of control's parent where error/valid message should be added (fallback to direct parent if not found); or "false" to use control's direct parent
	messageParentClass: false,

	// CSS class for an invalid control
	controlErrorClass: 'has-error',

	// CSS class for a valid control
	controlValidClass: 'has-success',

	// CSS class for an error message
	messageErrorClass: 'd-block help-block text-danger mt-1',

	// control with this CSS class will show error/valid message even when control itself is hidden (useful for controls which are hidden and wrapped into special component)
	enableHiddenMessageClass: 'show-hidden-error',

	// control with this CSS class will have disabled live validation
	disableLiveValidationClass: 'no-live-validation',

	// control with this CSS class will not show valid message
	disableShowValidClass: 'no-show-valid',

	// tag that will hold the error/valid message
	messageTag: 'span',

	// message element id = control id + this postfix
	messageIdPostfix: '_message',

	// show this html before error message itself
	messageErrorPrefix: '<i class="far fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;',

	// show all errors when submitting form; or use "false" to show only first error
	showAllErrors: true,

	// show message when valid
	showValid: false,

	// delay in ms before validating on keyup/keydown; or use "false" to disable it
	wait: false,

	// vertical screen offset in px to scroll after focusing element with error (useful when using fixed navbar menu which may otherwise obscure the element in focus); or use "false" for default behavior
	focusScreenOffsetY: false
}